<template>
  <div class="sku-ranking" ref="chartContainer"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { TooltipComponent, GridComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { skuRanking } from '../mock/data'

echarts.use([BarChart, TooltipComponent, GridComponent, CanvasRenderer])

/* 平台颜色映射 */
const platformColorMap = {
  '淘宝/天猫': '#00D4FF',
  '京东': '#00FF88',
  '拼多多': '#FF6B35',
  '抖音': '#A855F7'
}

/* 将十六进制颜色转为 rgba */
function hexToRgba(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16)
  var g = parseInt(hex.slice(3, 5), 16)
  var b = parseInt(hex.slice(5, 7), 16)
  return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')'
}

export default {
  name: 'SkuRanking',
  data: function () {
    return {
      chart: null
    }
  },
  mounted: function () {
    this.initChart()
    this._resizeHandler = this.handleResize.bind(this)
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this._resizeHandler)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart: function () {
      this.chart = echarts.init(this.$refs.chartContainer)

      /* 取 Top8，按销售额降序排列后取前8，再反转让最大值在图表顶部 */
      var top8 = skuRanking.slice().sort(function (a, b) { return b.sales - a.sales }).slice(0, 8)
      var displayData = top8.slice().reverse()

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            var idx = params[0].dataIndex
            var item = displayData[idx]
            return '<div style="font-size:12px">' +
              '<div style="font-weight:bold;margin-bottom:4px">' + item.name + '</div>' +
              '<div>平台：' + item.platform + '</div>' +
              '<div>销售额：' + (item.sales / 10000).toFixed(1) + '万元</div>' +
              '<div>销量：' + item.quantity + '</div>' +
              '<div>增长率：' + (item.growth > 0 ? '+' : '') + item.growth + '%</div>' +
              '</div>'
          }
        },
        grid: { left: 100, right: 60, top: 5, bottom: 5 },
        xAxis: { show: false, type: 'value' },
        yAxis: {
          type: 'category',
          data: displayData.map(function (item, i) {
            return (8 - i) + '. ' + item.name
          }),
          axisLabel: { color: '#B0D4F1', fontSize: 10 },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: [{
          type: 'bar',
          data: displayData.map(function (item) {
            var color = platformColorMap[item.platform] || '#00D4FF'
            return {
              value: item.sales,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: hexToRgba(color, 0.15) },
                  { offset: 1, color: color }
                ]),
                borderRadius: [0, 3, 3, 0]
              }
            }
          }),
          barWidth: '60%',
          label: {
            show: true,
            position: 'right',
            color: '#B0D4F1',
            fontSize: 10,
            formatter: function (params) {
              return (params.value / 10000).toFixed(1) + '万元'
            }
          }
        }]
      }

      this.chart.setOption(option)
    },
    handleResize: function () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.sku-ranking {
  width: 100%;
  min-height: 200px;
  overflow: hidden;
}
</style>
